import React, { useEffect, useRef, useState } from 'react'
import * as d3 from 'd3'
import './styles.scss'
import lausanneMean from './lausanne.csv'
import lausanneDots from './dots.csv'

export const NoiseGraph = () => {
  const canvasNode = useRef(null)
  const counterNode = useRef(null)
  const svgNode = useRef(null)
  const ticker = useRef(null)
  const counter = useRef(0)
  const tick = useRef(0)
  const [size, setSize] = useState({ width: 100, height: 100 })
  const dots = useRef([])
  const margin = { top: 50, right: 50, bottom: 50, left: 100 }
  const svg = d3.select(svgNode.current)

  const xScale = d3
    .scaleLinear()
    .domain([0, 23])
    .range([0, size.width * 0.85 - margin.left - margin.right])

  const yScale = d3
    .scaleLinear()
    .domain([40, 80])
    .range([size.height - margin.top - margin.bottom, 0])

  const poly = [
    { x: 0, y: 80 },
    { x: 0, y: 65 },
    { x: 16, y: 65 },
    { x: 16, y: 55 },
    { x: 23, y: 55 },
    { x: 23, y: 80 }
  ]

  const svgContent = svg
    .append('g')
    .attr('transform', `translate(${margin.left}, ${margin.top})`)

  // define the line
  const valueline = d3
    .line()
    .x(d => xScale(d.date))
    .y(d => yScale(d.close))

  // format the data
  lausanneMean.forEach(d => {
    d.date = +d.pos
    d.close = +d.average_overall
  })

  lausanneDots.forEach(d => {
    d.date = (+d.pos * 23) / 1440
    d.close = +d.val
  })

  console.log(lausanneMean)
  console.log(lausanneDots)

  // add the valueline path.
  svgContent
    .selectAll('path')
    .data([lausanneMean])
    .enter()
    .append('path')
    .attr('class', 'line')
    .attr('d', valueline)

  svgContent
    .selectAll('polygon')
    .data([poly])
    .enter()
    .append('polygon')
    .attr('class', 'limit')
    .attr('points', d => {
      return d
        .map(d => {
          return [xScale(d.x), yScale(d.y)].join(',')
        })
        .join(' ')
    })

  svgContent
    .append('line')
    .attr('class', 'cursor')
    .attr('x1', xScale(12))
    .attr('y1', yScale(80))
    .attr('x2', xScale(12))
    .attr('y2', yScale(40))

  svgContent
    .append('rect')
    .attr('class', 'cursor')
    .attr('x', xScale(5) - 50)
    .attr('y', yScale(1))
    .attr('width', 100)
    .attr('height', 20)

  function make_y_gridlines() {
    return d3.axisLeft(yScale).ticks(10)
  }

  svgContent
    .append('g')
    .attr('class', 'grid')
    .call(
      make_y_gridlines()
        .tickSize(-size.width + margin.left + margin.right)
        .tickFormat(v => (v === 80 ? v + 'db' : v))
    )

  svgContent
    .append('line')
    .attr('class', 'limit')
    .attr('x1', 0)
    .attr('y1', yScale(65))
    .attr('x2', xScale(16))
    .attr('y2', yScale(65))

  svgContent
    .append('line')
    .attr('class', 'limit')
    .attr('x1', xScale(16))
    .attr('y1', yScale(55))
    .attr('x2', xScale(23))
    .attr('y2', yScale(55))

  const addDot = () => {
    dots.current = [
      ...dots.current,
      {
        x: size.width,
        y: yScale(40 + Math.random() * 40),
        t: tick.current,
        r: 3,
        a: 1,
        anim: false
      }
    ]
  }

  const update = t => {
    dots.current.forEach(d => {
      d.x -= 1
      d.r += (3 - d.r) * 0.01

      if (d.x < size.width / 2 && !d.anim) {
        d.anim = true
        d.r = Math.pow(yScale(0) - d.y, 3) * 0.00000005
        counter.current += 1
        counterNode.current.innerHTML = counter.current
      }
    })

    // lausanneDots.forEach(d => {
    //     d.x -= 1
    //     d.r += (3 - d.r) * 0.01

    //     if (d.x < size.width / 2 && !d.anim) {
    //       d.anim = true
    //       d.r = 30
    //       counter.current += 1
    //       counterNode.current.innerHTML = counter.current
    //     }
    //   })
  }

  const draw = () => {
    const ctx = canvasNode.current.getContext('2d')
    ctx.clearRect(0, 0, size.width, size.height)

    dots.current.forEach(d => {
      ctx.fillStyle = `rgba(242, 169, 81, ${d.a})`
      ctx.beginPath()
      ctx.arc(d.x, d.y, d.r, 0, 2 * Math.PI)
      ctx.fill()
    })

    lausanneDots.forEach(d => {
      if (xScale(d.date) > 0 && xScale(d.date) < size.width) {
        if ((d.close > 65 && d.date < 16) || (d.close > 55 && d.date > 16)) {
          ctx.fillStyle = `rgba(242, 169, 81, 0.5)`
          // ctx.strokeStyle = `rgba(242, 169, 81, 0.5)`
        } else {
          ctx.fillStyle = `rgba(90, 90, 90, 0.5)`
          // ctx.strokeStyle = `rgba(90, 90, 90, 0.5)`
        }
        ctx.beginPath()
        ctx.arc(
          margin.left + xScale(d.date),
          margin.top + yScale(d.close),
          3,
          0,
          2 * Math.PI
        )
        ctx.fill()
        // ctx.beginPath()
        // ctx.moveTo(margin.left + xScale(d.date), margin.top + yScale(d.close))
        // ctx.lineTo(margin.left + xScale(d.date), margin.top + yScale(d.close) + 10)
        // ctx.stroke()
      }
    })
  }

  // Set the size of the canvas
  const resize = () => {
    const ratio = 9 / 16

    setSize({
      width: window.innerWidth * window.devicePixelRatio,
      height: window.innerWidth * ratio * window.devicePixelRatio
    })
  }

  const handleResize = () => {
    resize()
  }

  // Start the ticker
  ticker.current = d3.timer(t => {
    update(t)
    draw()
    tick.current = t
  }, 150)

  useEffect(() => {
    // Set the correct size of the canvas
    resize()

    // Set the correct size after a window resize
    window.addEventListener('resize', handleResize)

    // Cleanup the resize listener when the componenet is unmounted
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div
      className='noise-graph'
      onClick={() => {
        addDot()
      }}
    >
      <div className='counter-container'>
        <div>Secondes de souffrance</div>
        <div ref={counterNode}>0</div>
      </div>
      <div className='shade left' />
      <div className='shade right' />
      <canvas ref={canvasNode} width={size.width} height={size.height} />
      <svg ref={svgNode} width={size.width} height={size.height} />
    </div>
  )
}
